import React from 'react';

interface IProps {
  trackerId: string;
}

export default class SneakyTracker extends React.Component<IProps> {
  public render() {
    return <div ref={this.setElement}>{this.props.children}</div>;
  }

  private setElement = element => {
    if (typeof window === 'undefined') {
      return;
    }
    if ((window as any).odSneakyTrackers === undefined) {
      (window as any).odSneakyTrackers = {};
    }
    (window as any).odSneakyTrackers[this.props.trackerId] = element;
  };
}
